export default __webpack_public_path__ + "static/media/Slide6.e6e1a58e.jpeg";